<template>
  <section class="py-16 px-4 max-w-3xl mx-auto text-gray-800 text-center">

    <!-- Bild im großen Viereck -->
    <div class="inline-block bg-gray-100 rounded-lg">
      <img
          src="/AboutMe.png"
          alt="Portrait of Melissa McCallum"
          class="w-80 h-80 object-cover rounded-lg"
      />
    </div>

    <!-- Text -->
<div class="text-center mt-8 mb-12">
  <!-- Linie oben -->
  <div class="w-40 h-[3px] mx-auto mb-3 rounded-full bg-gradient-to-r from-blue-100 via-green-100 to-blue-200"></div>

  <!-- Überschrift -->
  <h2 class="text-2xl font-semibold text-gray-800">
    About Me
  </h2>

  <!-- Linie unten -->
  <div class="w-40 h-[3px] mx-auto mt-3 rounded-full bg-gradient-to-l from-blue-100 via-green-100 to-blue-200"></div>
</div>
    <p class="mb-4">
      I am a fully qualified and insured psychotherapist working with adults. I offer a safe, confidential space where you can talk openly and feel heard.
    </p>
    <p class="mb-4">
      My aim is to support you in making sense of your feelings, experiences, and relationships. Together, we explore patterns, beliefs, and behaviours that may be impacting your well-being.
    </p>
    <p>
      I work integratively, drawing on approaches such as psychodynamic, person-centred, and cognitive behavioural therapy (CBT) to meet your individual needs.
    </p>
  </section>
</template>

<script setup>
// nichts nötig
</script>
